var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileScreenButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M304 0H80C53.5 0 32 21.5 32 48V464C32 490.5 53.5 512 80 512H304C330.5 512 352 490.5 352 464V48C352 21.5 330.5 0 304 0ZM336 464C336 481.645 321.645 496 304 496H80C62.355 496 48 481.645 48 464V368H336V464ZM336 352H48V48C48 30.355 62.355 16 80 16H304C321.645 16 336 30.355 336 48V352ZM192 464C209.674 464 224 449.672 224 432S209.674 400 192 400C174.328 400 160 414.328 160 432S174.328 464 192 464ZM192 416C200.822 416 208 423.176 208 432S200.822 448 192 448S176 440.824 176 432S183.178 416 192 416Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileScreenButton);
export default __webpack_public_path__ + "static/media/mobile-screen-button.37da70b22b4b864f40d75eadaff0d167.svg";
export { ForwardRef as ReactComponent };